import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import cx from 'classnames';
import {  MyPATSelect } from '../../../common';
import{styles} from '../../styling/component/MilestoneDetails/SuggestedContentCard';

import StarIcon from '@material-ui/icons/Star';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import VisibilityIcon from '@material-ui/icons/Visibility';
import courseService from '../../services/courseService';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
	WithStyles,
	createStyles,
	Typography,
	Paper,
	Grid,
	Checkbox,
	IconButton,
	Chip,
	Button,
} from '@material-ui/core';


import { MyPATLink, dateService } from '../../../common';
import { red } from '@material-ui/core/colors';
import { ArrowRight } from '@material-ui/icons';

const suggestedFilter = [
	{name:"All",value:"All Type"},
	{name:"testpapers",value:"Test Papers"},
	{name:"question",value:"Question"},
	{name:"formulas",value:"Formulas"},
	{name:"sampleproblem",value:"Sample Problems"},
	{name:"videos",value:"Videos"},
	{name:"studymaterial",value:"Study Material"},
	
];
//@ts-ignore
interface SuggestedContentCardProps extends WithStyles<typeof styles> {
	classes: any,
	userId: string,
	contentType: any,
	contentSubtype: any,
	index: number,
	chapterId: string,
	addSuggestedContent:Function
}

interface SuggestedContentCardStates {
	suggestedContent: any;
    contentLimit:number
}

class SuggestedContentCard extends Component<SuggestedContentCardProps, SuggestedContentCardStates>{
	defaultContent: any = null;
	constructor(public props: SuggestedContentCardProps) {
		super(props);
		this.state = {
			suggestedContent: [],
			contentLimit:3
		};
		this.getSuggestedContentList = this.getSuggestedContentList.bind(this);
		this.viewAll = this.viewAll.bind(this);
	}
	addToCourse()
	{

	}
	viewAll()
	{
       this.setState({contentLimit:this.state.suggestedContent.length})
	}
	handleChange = (e: { target: { name: "low" | "high", value: string } }) => {
		var { name, value } = e.target;
		this.getSuggestedContentList(value);
	}
	getSuggestedContentList(type:string)
	{
	   
			courseService.getSuggestedContent(this.props.chapterId, type).then((suggestedContent: any) => {
				var self = this;
				self.setState({ suggestedContent: suggestedContent });
			});
	}

	componentWillMount() {
		this.getSuggestedContentList('All');
	}
	render() {
		
		const { classes, userId, chapterId,addSuggestedContent,contentType } = this.props;
		var self= this;
		var suggestedGridList = "";
		if (this.state.suggestedContent.length > 0) {
			suggestedGridList = this.state.suggestedContent.map(function (v: any, i: any) {
			if(i<self.state.contentLimit)
				{
				return <Paper style={{ float: "left", paddingRight: "1px" }} className={classes.paper} elevation={1} >
					<Grid container >
						<Grid item xs={12}>
							<Grid container>
								<Grid item xs={8}>
									<Typography variant="subtitle1" className={cx(classes.title, classes.textEllipsis)}>
										{v.title}
									</Typography>
								</Grid>
								<Grid item xs={2}>
									<div style={{ borderRadius: '20px' }} className="content-preview">
										<Button variant="contained" size="small" className={classes.previewButton}>
											{v.contentTypeCode}
									</Button>
									</div>
								</Grid>
							</Grid>
						</Grid>
						<Grid item xs={12}>
							<Grid container>
								<Grid item xs={2}>
									<img style={{ width: '25px', height: '25px' }} alt="no content" className={classes.img} src="/assets/img/course/playbutton.png" />
								</Grid>
								<Grid item xs={10}>
									<Typography variant="body1" className={classes.subTitle}>
										{v.title}
										</Typography>
								</Grid>
							</Grid>
						</Grid>
						<Grid item xs={12}>
							<Grid container>
								<Grid item xs={4}>
									<Typography variant="subtitle1">
										Likes: {v.likes || 0}
											</Typography>
								</Grid>
								<Grid item xs={4}>
									<Typography variant="subtitle1">
										Views:{v.views || 0}
											</Typography>
								</Grid>
								<Grid item xs={3}>
									<div className="content-preview">
										<Button onClick={(e: any) => { addSuggestedContent(v,chapterId,contentType) }} variant="contained" size="small" className={classes.previewButton}>
											ADD
									</Button>
									</div>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Paper>
				}
			})
		}
		return (

			<div style={{ width: "100%", overflowX: "scroll" }}>
				<Grid item xs={12} className={classes.selectGoale}>

				<Grid container>
						<Grid item xs={2}>
								<Typography style={{marginTop:"5px"}} variant="body2" >
								Suggested Content  
								</Typography>
						</Grid>
						<Grid style={{marginLeft:"-30px",color:"#323C47", fontSize:"14px"}} item xs={3}>
								<MyPATSelect
								label=""
								style={{background:"none",width:""}}
								inputId="Target_year"
								name="Target_year"
								defaultValue=""
								onChange={self.handleChange}
								inputProps={{
								required: true,
								style:{background:"none",border:"none",fontSize:"12px"}
								}}
								>
								{suggestedFilter.map((v,i)=>{
								return (
								<option key={`${v.name} ${i}`} value={v.name}>{v.value}</option>
								);
								})
								}
						</MyPATSelect>
					</Grid>
					{/* <Grid item xs={5}></Grid> */}
					
				</Grid>
			</Grid>	
			<Grid>
					<Typography variant="caption" style={{color:"#999999"}}>
						Add more videos to enhance the learning experience
					</Typography>
					<Grid onClick={() => { this.viewAll() }} style={{float:"right",marginTop:"-21px",cursor:'pointer'}}	 item xs={1}>
					<Typography variant="body2">Browse All</Typography></Grid>
					</Grid>
			  	{suggestedGridList}
			</div>
		);
	}
}
// @ts-ignore
export default connect(null)(withStyles(styles)(SuggestedContentCard));

